/**
 * @file
 * Provide methods for initializing jQuery UI-Tooltips.
 */

(function ($, Drupal) {
  Drupal.behaviors.tooltip = {
    attach: function attach(context) {
      once('awTooltip', '.js-tooltip').forEach(function(currentElement) {
        $(currentElement).tooltip({
          items: '.js-tooltip',
          content: function () {
            return $(this).parents('.tooltip').find('.js-tooltip-text').html();
          },
          position: {
            my: "left-20 bottom-5",
            at: "left top",
            collision: "flipfit",
            using: function (position, feedback) {
              $(this).css(position);
            }
          },
        });
      });
    }
  };
})(jQuery, Drupal);
